import { toast } from 'react-toastify'
import type { ImageUploadResponse } from '../shared/shared.type'
import { imagesApiSlice } from '../api/apiSlice'

export const miscApiSlice = imagesApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation<ImageUploadResponse, FormData>({
      query: (payload) => ({
        url: `v1/image/upload`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (error) {
          toast.error(error as string)
        }
      },
    }),
  }),
})

export const { useUploadImageMutation } = miscApiSlice
